import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'

import Home from '@/components/Home'
import Contact from '@/components/Contact'
import NotFound from '@/components/NotFound'

Vue.config.productionTip = false

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/contact',
      component: Contact
    },
    {
      path: '*',
      component: NotFound
    }
  ],
})

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
